import { useLiveQuery } from 'dexie-react-hooks';
import { useStockMap } from './catalog';
import { db } from './db';

const DAY = 86400000;

/** Batches in stock that expire within 3 days (Home alert). */
export function useExpiringCount(): number {
  const batches = useLiveQuery(() => db.batches.where('expiry').below(Date.now() + 3 * DAY).toArray(), []);
  const stock = useStockMap();
  return (batches ?? []).filter((b) => (stock.get(b.product_id) ?? 0) > 0).length;
}
